import "../Left/Left.css"
import { motion } from 'framer-motion';
import { Typewriter } from "react-simple-typewriter";
export default function Left(){
    return <div style={{display:"flex",flexDirection:'column',padding:"20px"}}>
        <motion.span 
        initial={{y:-40,opacity:0}}
        animate={{y:0,opacity:1}}
        transition={{duration:0.5,delay:0.2}}
        className="name">
        <span
        >Ankit </span>
        <span>Kumar</span>
        <span> Shah</span></motion.span>   
       <motion.div initial={{y:40,opacity:0}}
        animate={{y:0,opacity:1}}
        transition={{duration:0.5,delay:0.7}}>
       <div 
       className="quality">
       <span style={{
        fontSize:"3.5rem",
        color:"white",
        fontWeight:"200"
       }}>I am </span>
       <Typewriter words={['Application Developer','Full Stack Developer','Inquisitive','Tech Enthusiast']} loop={0} cursor={true} cursorBlinking={true} cursorStyle={'_'} typeSpeed={90}
            deleteSpeed={90}
            delaySpeed={2000}/>
       </div>
       <p style={{
        color:"white",
        fontSize:"1.7rem",
        fontWeight:"200",
        letterSpacing:"2px",
        paddingTop:"40px",
       }}>
       I am an Enthusiastic and Inquisitive Software Developer Fresher currenty student at Lovely Professional University.
       </p>
       </motion.div>

        </div>
}